import type { QueryHookResult } from '@change-corgi/core/react/async';
import { useQuery } from '@change-corgi/core/react/async';

import { usePlacesService } from 'src/app/shared/hooks/googlePlaces';

import { getPlaceDetails } from '../api/getPlaceDetails';

export function usePlaceDetails(placeId: string | undefined): UsePlaceDetailsResult {
	const placesService = usePlacesService();

	return useQuery(
		async () => {
			if (!placeId) {
				return { status: 'loading' };
			}
			return {
				data: await getPlaceDetails(placeId, placesService),
			};
		},
		[placeId, placesService],
		{
			loadingBetweenQueries: true,
		},
	);
}

export type UsePlaceDetailsResult = QueryHookResult<{ data: google.maps.places.PlaceResult }>;
